module.exports = __webpack_public_path__ + "media/images/marisol_malhas-d3db60271d8cfef006c71df3b781c8c4.jpg";